import * as React from "react";
import PropTypes from "prop-types";
const SvgActivityDistanceNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M18.479 29.21c-.467.554-.858.995-1.133 1.3-.438.484-.895.952-1.346 1.424l-1.346-1.425a56.531 56.531 0 01-4.561-5.798C7.64 21.121 5 16.257 5 11.768c0-3.635 1.442-6.367 3.59-8.17C10.709 1.82 13.443 1 16 1s5.292.82 7.41 2.597C25.557 5.401 27 8.133 27 11.768c0 4.489-2.641 9.353-5.093 12.943a56.531 56.531 0 01-3.428 4.5zM7.5 11.768c0 3.67 2.234 7.984 4.657 11.533A54.035 54.035 0 0016 28.261a54.035 54.035 0 003.843-4.959c2.423-3.55 4.657-7.864 4.657-11.534 0-2.91-1.126-4.937-2.698-6.256C20.198 4.166 18.058 3.5 16 3.5s-4.198.666-5.802 2.012C8.626 6.832 7.5 8.858 7.5 11.768z" />
        <path d="M16 6.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM13 12a3 3 0 116 0 3 3 0 01-6 0z" />
      </g>
    </svg>
  )
);
SvgActivityDistanceNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActivityDistanceNormalMedium;
